import { render, staticRenderFns } from "./JInputNumber.vue?vue&type=template&id=2d38bc50&scoped=true&"
import script from "./JInputNumber.vue?vue&type=script&lang=js&"
export * from "./JInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./JInputNumber.vue?vue&type=style&index=0&id=2d38bc50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38bc50",
  null
  
)

export default component.exports